import { render, staticRenderFns } from "./client-management.vue?vue&type=template&id=d64f8f10&scoped=true"
import script from "./client-management.vue?vue&type=script&lang=js"
export * from "./client-management.vue?vue&type=script&lang=js"
import style0 from "./client-management.vue?vue&type=style&index=0&id=d64f8f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64f8f10",
  null
  
)

export default component.exports